export enum ErrorHandlingModeEnum {
  DEFAULT = "default",
  STANDARD = "standard",
}
